import React from "react";
import { Link } from "react-router-dom";

const BannerTwo = () => {
  return (
    <div className="banner-two">
      <div className="banner-item-two-wrapper overflow-hidden position-relative flex-grow-1 mb-0">
        {/* Background Image */}
        <img
          src="assets/images/bg/banner-two.jpg"
          alt="Banner"
          className="banner-bg-img"
        />

        {/* Dark Overlay */}
        <div className="banner-overlay"></div>

        {/* CENTERED CONTENT */}
        <div className="banner-two-content-wrapper text-center d-flex flex-column align-items-center justify-content-center">
          {/* CENTER TEXT */}
          <div className="banner-text text-center w-100">
            <h2 className="banner-heading">
              Smart, Reliable & Affordable
              <br />
              Printing Starts Here
            </h2>

            <p className="banner-description">
              Get the perfect printers and genuine ink supplies for your home or
              office. Designed for high-quality output, wireless printing, and
              long-term savings — delivered fast, backed by expert support.
            </p>
          </div>

          {/* 4 IMAGES BELOW */}
          <div className="container mt-4">
            <div className="row justify-content-center align-items-center">
              <div className="col-6 col-sm-3 mb-3">
                <Link
                  to="/hp-printers"
                  className="banner-img-box d-flex justify-content-center align-items-center"
                >
                  <img
                    src="assets/hp.png"
                    alt="Printer 1"
                    className="banner-side-img img-fluid"
                  />
                </Link>
              </div>
              <div className="col-6 col-sm-3 mb-3">
                <Link
                  to="/canon-printers"
                  className="banner-img-box d-flex justify-content-center align-items-center"
                >
                  <img
                    src="assets/canon.png"
                    alt="Printer 2"
                    className="banner-side-img img-fluid"
                  />
                </Link>
              </div>
              <div className="col-6 col-sm-3 mb-3">
                <Link
                  to="/brother-printers"
                  className="banner-img-box d-flex justify-content-center align-items-center"
                >
                  <img
                    src="assets/brother.png"
                    alt="Printer 3"
                    className="banner-side-img img-fluid"
                  />
                </Link>
              </div>
              <div className="col-6 col-sm-3 mb-3">
                <Link
                  to="/epson-printers"
                  className="banner-img-box d-flex justify-content-center align-items-center"
                >
                  <img
                    src="assets/epson.png"
                    alt="Printer 4"
                    className="banner-side-img img-fluid"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Inline Style */}
      <style>{`
        .banner-bg-img {
          width: 100%;
          object-fit: cover;
          display: block;
        }

        .banner-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.45);
          z-index: 1;
        }

        .banner-two-content-wrapper {
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 2;
          color: #fff;
          text-align: center;
          padding: 40px 20px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        .banner-heading {
          font-size: 42px;
          font-weight: 700;
          line-height: 1.3;
          margin-bottom: 20px;
        }

        .banner-description {
          margin: 0 auto;
          font-size: 18px;
          opacity: 0.9;
          max-width: 720px;
        }

        .banner-img-box {
          background: rgba(255, 255, 255, 0.15);
          height: 180px;
          border-radius: 12px;
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
          transition: transform 0.4s ease, box-shadow 0.4s ease;
        }

        .banner-img-box:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 18px rgba(0, 0, 0, 0.3);
        }

       .banner-side-img {
          width: 50%;
          height: auto;
          object-fit: cover;
          cursor: pointer;
          border-radius: 14px;
          margin-top: 10px;
          filter: drop-shadow(0 8px 20px rgba(0, 0, 0, 0.35));
          transition: transform 0.4s ease, filter 0.4s ease;
              background: linear-gradient(145deg, rgba(255, 255, 255, 0.9), rgba(240, 240, 240, 0.6));
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: inset 2px 2px 8px rgba(255, 255, 255, 0.8), inset -2px -2px 6px rgba(0, 0, 0, 0.05);
    padding:20px
        }

        .banner-side-img:hover {
          transform: scale(1.05);
          filter: drop-shadow(0 12px 28px rgba(0, 0, 0, 0.45));
        }

        @media (max-width: 992px) {
          .banner-heading {
            font-size: 34px;
          }
          .banner-description {
            font-size: 16px;
            max-width: 90%;
          }
        }

        @media (max-width: 768px) {
          .banner-heading {
            font-size: 28px;
          }
          .banner-description {
            font-size: 15px;
            line-height: 1.5;
          }
        }

        @media (max-width: 480px) {
          .banner-heading {
            font-size: 22px;
          }
          .banner-description {
            font-size: 14px;
          }
        }
      `}</style>
    </div>
  );
};

export default BannerTwo;
